import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntEmptyDividerComponent} from "./int-empty-divider.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntEmptyDividerComponent
  ],
  exports: [
    IntEmptyDividerComponent
  ]
})
export class IntEmptyDividerModule {}
